import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

const PoliticaCookies = () => {
    return (
        <LegalPageLayout
            seoTitle="Política de Cookies"
            path="/politica-cookies"
            description="Política de cookies del sitio web de Coralan Multiservice SRL: qué cookies usamos, con qué finalidad y cómo gestionarlas."
            breadcrumbLabel="Política de Cookies"
            title="Política de Cookies"
            subtitle="Información sobre el uso de cookies en el sitio web de Coralan Multiservice SRL."
            lastUpdated="Enero 2026"
        >
            <div className="legal-page__content">
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">¿Qué son las cookies?</h2>
                    <p>
                        Las cookies son pequeños archivos de texto que se almacenan en su
                        dispositivo cuando visita nuestro sitio web. Nos ayudan a recordar
                        sus preferencias y a mejorar su experiencia.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">Tipos de cookies que utilizamos</h2>

                    <div className="legal-page__subblock">
                        <div className="legal-page__subblock-title">
                            Cookies Técnicas (Necesarias)
                            <span className="legal-page__subblock-tag">
                                No requieren consentimiento
                            </span>
                        </div>
                        <p>
                            Esenciales para el funcionamiento del sitio web. Sin estas cookies,
                            el sitio no funciona correctamente. Incluyen:
                        </p>
                        <ul>
                            <li>Cookies de sesión para mantener su navegación activa.</li>
                            <li>Cookies de seguridad para prevenir ataques.</li>
                            <li>Cookies de preferencias básicas de la interfaz.</li>
                        </ul>
                    </div>

                    <div className="legal-page__subblock">
                        <div className="legal-page__subblock-title">
                            Cookies Analíticas
                            <span className="legal-page__subblock-tag legal-page__subblock-tag--required">
                                Requieren consentimiento
                            </span>
                        </div>
                        <p>
                            Nos permiten entender cómo los visitantes interactúan con nuestro
                            sitio web:
                        </p>
                        <ul>
                            <li>Páginas más visitadas y tiempo de permanencia.</li>
                            <li>Rutas de navegación de los usuarios.</li>
                            <li>Datos de rendimiento del sitio.</li>
                        </ul>
                    </div>

                    <div className="legal-page__subblock">
                        <div className="legal-page__subblock-title">
                            Cookies de Funcionalidad
                            <span className="legal-page__subblock-tag legal-page__subblock-tag--required">
                                Requieren consentimiento
                            </span>
                        </div>
                        <p>Recuerdan sus preferencias para mejorar su experiencia:</p>
                        <ul>
                            <li>Idioma seleccionado.</li>
                            <li>Configuraciones personalizadas.</li>
                        </ul>
                    </div>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">¿Cómo gestionar las cookies?</h2>
                    <p>
                        Puede gestionar o deshabilitar las cookies desde la configuración
                        de su navegador:
                    </p>
                    <ul>
                        <li>
                            <strong>Google Chrome:</strong> Configuración &gt; Privacidad y
                            seguridad &gt; Cookies
                        </li>
                        <li>
                            <strong>Mozilla Firefox:</strong> Configuración &gt; Privacidad
                            y seguridad
                        </li>
                        <li>
                            <strong>Safari:</strong> Preferencias &gt; Privacidad
                        </li>
                        <li>
                            <strong>Microsoft Edge:</strong> Configuración &gt; Privacidad
                        </li>
                    </ul>
                    <p>
                        Tenga en cuenta que deshabilitar algunas cookies puede afectar la
                        funcionalidad del sitio.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">Cookies de terceros</h2>
                    <p>
                        Nuestro sitio puede utilizar servicios de terceros (como Google
                        Analytics) que instalan sus propias cookies. Estos servicios están
                        sujetos a sus propias políticas de privacidad.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">Actualizaciones</h2>
                    <p>
                        Esta política puede actualizarse periódicamente. Le recomendamos
                        revisarla regularmente.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">Contacto</h2>
                    <p>
                        Para consultas sobre cookies:{' '}
                        <strong>info@coralanmultiservice.com</strong>
                    </p>
                </div>

                <div className="legal-page__cta">
                    <div className="legal-page__cta-text">
                        <p className="legal-page__cta-title">¿Necesitas más información?</p>
                        <p className="legal-page__cta-subtitle">
                            Contacta a nuestro equipo de soporte para cualquier consulta.
                        </p>
                    </div>
                    <Link to="/soporte" className="legal-page__cta-btn">
                        Ir a Soporte <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </LegalPageLayout>
    );
};

export default PoliticaCookies;
